import styled, { keyframes } from 'styled-components';
import { marginStyles } from '../../styles/components.js';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';

const fade = keyframes `
  0%,
  80%,
  100% {
    opacity: 0.5;
    transform: scale(0.4);
  }
  40% {
    opacity: 1;
    transform: scale(0.6);
  }
`;
const Wrapper = styled.div `
  height: 16px;
  width: 70px;
  text-align: center;
  ${props => marginStyles(props.margin ? props.margin : '0 auto')};

  > div {
    width: 14px;
    height: 14px;
    background-color: ${props => props.color
    ? props.theme.colors.content[props.color]
    : mapBackgroundToContentColor({
        backgroundColor: props.backgroundColor,
        theme: props.theme,
    })};

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: ${fade} 0.8s infinite ease-in-out both;
    animation: ${fade} 0.8s infinite ease-in-out both;

    &:nth-child(1) {
      animation-delay: -0.25s;
    }

    &:nth-child(2) {
      animation-delay: -0.125s;
    }
  }
`;

export { Wrapper };
